var _effectorFileName = "/builds/gmini/front-ui-kit/src/DialogContentText/DialogContentText.tsx";
import { DialogContentTextWrapper } from './DialogContentText.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogContentText = ({
  children,
  color = 'textSecondary',
  ...props
}) => /*#__PURE__*/_jsx(DialogContentTextWrapper, {
  color: color,
  ...props,
  children: children
});